<div class="min-h-screen bg-white">
  <header class="border-b">
    <div class="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-4">
      <div class="flex items-center gap-3">
        <app-logo [widthInPx]="110" />
        <span hlmMuted class="hidden text-sm sm:inline">Partnerbereich</span>
      </div>
      <div class="flex items-center gap-3">
        <span class="text-sm font-medium">{{ partnerService.name() }}</span>
        <button hlmBtn variant="ghost" size="sm" type="button" (click)="logout()">
          <ng-icon name="lucideLogOut" data-icon="inline-start" />
          Abmelden
        </button>
      </div>
    </div>
  </header>

  <main class="mx-auto flex max-w-5xl flex-col gap-6 px-4 py-8">
    <!-- Right after sign-up the partner gives its name first -->
    @if (overview()?.profile_completed === false) {
      <app-partner-profile-step (saved)="load()" />
    } @else {
      <div class="flex flex-wrap items-center justify-between gap-3">
        <h1 hlmH3>Deine Kunden</h1>
        <app-add-client-menu
          (createNew)="notice.set(null); createOpen.set(true)"
          (addExisting)="notice.set(null); requestOpen.set(true)" />
      </div>

      @if (notice()) {
        <div hlmAlert role="status">
          <ng-icon name="lucideCircleCheck" />
          <p hlmAlertTitle>{{ notice() }}</p>
        </div>
      }
      @if (actionError()) {
        <div hlmAlert variant="destructive" role="alert">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ actionError() }}</p>
        </div>
      }

      @if (loading()) {
        <div class="space-y-4" aria-busy="true" aria-label="Wird geladen">
          <hlm-skeleton class="h-32 w-full rounded-xl" />
          <hlm-skeleton class="h-64 w-full rounded-xl" />
        </div>
      } @else if (error()) {
        <div hlmAlert variant="destructive">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ error() }}</p>
          <div hlmAlertAction>
            <button hlmBtn variant="outline" size="sm" type="button" (click)="load()">
              <ng-icon name="lucideRotateCw" />
              Erneut versuchen
            </button>
          </div>
        </div>
      } @else if (overview(); as o) {
        <app-partner-link-card [link]="o.link" />

        <section hlmCard aria-labelledby="partner-clients-title">
          <div hlmCardHeader>
            <h2 hlmCardTitle id="partner-clients-title">Kunden</h2>
            <p hlmCardDescription>
              Geschäfte, die du betreust oder die sich über deinen Link angemeldet haben.
            </p>
          </div>
          <div hlmCardContent>
            @if (o.clients.length === 0) {
              <div class="flex flex-col items-center gap-2 py-8 text-center">
                <ng-icon name="lucideUsers" class="text-muted-foreground text-2xl" />
                <p class="font-medium">Noch keine Kunden</p>
                <p hlmMuted class="max-w-md text-sm">
                  Füge einen Kunden hinzu, den du betreust, oder teile deinen Empfehlungslink mit
                  Geschäften, die Gutscheine verkaufen möchten.
                </p>
                <app-add-client-menu
                  variant="outline"
                  (createNew)="createOpen.set(true)"
                  (addExisting)="requestOpen.set(true)" />
              </div>
            } @else {
              <app-partner-client-list
                [clients]="o.clients"
                [opening]="opening()"
                (openClient)="openClient($event)"
                (resendClaim)="notice.set(null); claimMailFor.set($event)"
                (leave)="leaving.set($event)" />
            }
          </div>
        </section>
      }
    }
  </main>
</div>

<app-create-client-dialog
  [open]="createOpen()"
  (close)="createOpen.set(false)"
  (created)="onCreated($event)" />
<app-request-access-dialog
  [open]="requestOpen()"
  (close)="requestOpen.set(false)"
  (sent)="onAccessRequested($event)" />

<hlm-alert-dialog
  [state]="leaving() ? 'open' : 'closed'"
  (stateChanged)="onLeaveDialogState($event)">
  <hlm-alert-dialog-content *hlmAlertDialogPortal class="max-w-lg">
    <div hlmAlertDialogHeader>
      <h3 hlmAlertDialogTitle>{{ leaving()?.name || leaving()?.email }} nicht mehr betreuen?</h3>
      <p hlmAlertDialogDescription>
        Du kannst danach nicht mehr in seinem Konto arbeiten. Dein Kunde behält sein Konto mit allem
        darin. Kam er über dich zu Schenkwerk, bleibt er dir zugeordnet.
      </p>
    </div>
    <div hlmAlertDialogFooter>
      <button hlmAlertDialogCancel hlmBtn variant="outline" (click)="leaving.set(null)">
        Abbrechen
      </button>
      <button hlmAlertDialogAction hlmBtn variant="destructive" (click)="confirmLeave()">
        Nicht mehr betreuen
      </button>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>

<app-claim-mail-dialog
  [client]="claimMailFor()"
  (close)="claimMailFor.set(null)"
  (sent)="onClaimMailSent($event)" />
